/**
 * 剥掉阿里 CDN 已有处理后缀。
 * 例：xxx.jpg_sum.jpg / xxx.jpg_400x400.jpg / xxx.jpg_q50.jpg_.webp
 */
export function stripAlicdnProcessSuffix(url) {
    if (!url || typeof url !== "string") return url || "";
    let s = url.split("#")[0];
    const q = s.indexOf("?");
    if (q > 0) s = s.slice(0, q);

    // 循环剥离，兼容多层后缀
    let prev;
    do {
        prev = s;
        s = s
            .replace(/_\.webp$/i, "")
            .replace(/_sum\.jpe?g$/i, "")
            .replace(/_\d+x\d+(?:q\d+)?\.jpe?g$/i, "")
            .replace(/_q\d+\.jpe?g$/i, "");
    } while (s !== prev);

    return s;
}

/**
 * 列表缩略图地址规范化。
 * 注意：新版 alicdn 大量「.jpg 实为 webp」图，再拼 _100x100q10.jpg 会 404 返回 1x1 GIF，
 * 导致格子空白；故不再追加 CDN 尺寸后缀，由 CSS 缩放原图。
 * @param {string} url
 * @param {number} [_showImagesType] 保留参数兼容调用方，已忽略
 */
export function fillAlicdnImagePre(url, _showImagesType = 0) {
    if (!url || typeof url !== "string") return url || "";
    let newUrl = url;
    try {
        // 历史笔误 //:xxx → https:xxx
        if (newUrl.startsWith("//:")) {
            newUrl = "https:" + newUrl.slice(3);
        } else if (newUrl.startsWith("//")) {
            newUrl = "https:" + newUrl;
        }
    } catch (e) { /* ignore */ }
    return newUrl;
}
